import { Input } from "common/common.styled";
import Button from "components/Button";
import { Grid } from "components/Grid/Grid";
import { Loader } from "components/Loader/Loader.component";
import Modal from "components/Modal";
import Text from "components/Text";
import PageContent from "pages/PageContent";
import {
    ProfileContentWrapper,
    StraightLine,
    SubHeading,
} from "pages/PageContent/PageContent.styled";
import React from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { BiLoaderAlt } from "react-icons/bi";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import theme from "theme";
import {
    DeleteIcon,
    Photo,
    PhotoWrapper,
    UploadButton,
} from "./PhotosAndVideos.styled";
import { usePhotosAndVideos } from "./usePhotosAndVideos";

export const PhotosAndVideos: React.FC = React.memo(() => {
    const {
        isLoading,
        isFetching,
        isDeleting,
        imageBeingDeleted,
        userImages,
        isModalOpen,
        handleDeleteImage,
        handleSaveAndNext,
        handleFileUpload,
        toggleModal,
        handleBack,
    } = usePhotosAndVideos();
    return (
        <PageContent>
            <ProfileContentWrapper>
                {(isFetching || isLoading) && <Loader size={28} />}
                <Text
                    variant="heading5"
                    fontWeight="700"
                    color={theme.colors.grey.dark}
                >
                    Complete Your Profile (2/7)
                </Text>
                <SubHeading variant="label">
                    ADD PHOTOS (MINIMUM 3) <StraightLine />
                </SubHeading>
                <Grid
                    row={true}
                    columnGap={2}
                    rowGap={2}
                    marginTop={1}
                    marginBottom={2}
                >
                    {userImages.length > 0 &&
                        userImages.map((image) => (
                            <PhotoWrapper
                                key={image.id}
                                showLoader={
                                    isDeleting && imageBeingDeleted === image.id
                                }
                            >
                                <BiLoaderAlt id="loader" />
                                <Photo src={image.url} />
                                <DeleteIcon>
                                    <IoClose
                                        id="deleteIcon"
                                        size={20}
                                        onClick={() =>
                                            handleDeleteImage(image.id)
                                        }
                                    />
                                </DeleteIcon>
                            </PhotoWrapper>
                        ))}
                    <UploadButton htmlFor="upload">
                        <AiOutlinePlus fontWeight={700} />
                        {userImages.length === 0 && "Upload Image"}
                        <Input
                            type="file"
                            id="upload"
                            accept="image/png, image/jpg, image/jpeg"
                            onChange={handleFileUpload}
                        />
                    </UploadButton>
                </Grid>
                {/* <SubHeading variant="label">
                    ADD VIDEOS <StraightLine />
                </SubHeading>
                <Grid row={true} columnGap={2} marginTop={1} marginBottom={2}>
                    <Photo src={Model} alt="Model image" />
                    <Label htmlFor="upload">
                        <AiOutlinePlus fontWeight={700} />
                        <Input type="file" id="upload" />
                    </Label>
                </Grid> */}
                <Grid row={true} columnGap={1} marginTop={3} marginBottom={1}>
                    <Button
                        type="button"
                        variant="outlined"
                        icon={<BsArrowLeft />}
                        iconPosition="prefix"
                        onClick={toggleModal}
                    >
                        Back
                    </Button>
                    <Button
                        type="button"
                        variant="filled"
                        icon={<BsArrowRight />}
                        iconPosition="suffix"
                        onClick={handleSaveAndNext}
                    >
                        Next
                    </Button>
                </Grid>
            </ProfileContentWrapper>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <Modal.Header>
                    <Text variant="heading3">Confirm</Text>
                </Modal.Header>
                <Modal.Content>
                    <Text variant="body1">
                        Are you sure you want to leave? Any unsaved changes will
                        be lost.
                    </Text>
                </Modal.Content>
                <Modal.Footer>
                    <Grid
                        row={true}
                        justify="flex-end"
                        expanded
                        columnGap={1}
                        marginTop={2}
                    >
                        <Button
                            type="button"
                            variant="outlined"
                            onClick={toggleModal}
                        >
                            No
                        </Button>
                        <Button
                            type="button"
                            variant="filled"
                            onClick={handleBack}
                        >
                            Yes
                        </Button>
                    </Grid>
                </Modal.Footer>
            </Modal>
        </PageContent>
    );
});

PhotosAndVideos.displayName = "PhotosAndVideos";
